import { AxiosRequestConfig } from "axios";

export const postSignUpMicrosoftConfig: AxiosRequestConfig = {
  method: "post",
  url: "/user",
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
};
